"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.f = exports.d = exports.getDictionary = void 0;
const options_1 = __importDefault(require("./options"));
function getDictionary(name) {
    return options_1.default[name] || {};
}
exports.getDictionary = getDictionary;
exports.d = getDictionary;
exports.f = (row, column, cellValue, index) => {
    return (getDictionary(column.property) || {})[cellValue] || cellValue;
};
